class Config {
  static configData = null;
  static configUrl = "/dist/config.json"; // URL to fetch the configuration JSON
  static configPromise = null; // Promise to track the fetching process

  // Static method to initiate fetching the configuration if not already fetched
  static loadConfig() {
    if (!Config.configPromise) {
      Config.configPromise = fetch(Config.configUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to load configuration');
          }

          return response.json();
        })
        .then(data => {
          Config.configData = data;
          Config.defineProperties(data);
        })
        .catch(error => {
          console.error(error);
          throw new Error('Failed to load configuration');
        });
    }
    return Config.configPromise;
  }

  // Static method to define properties on the Config class
  static defineProperties(data) {
    for (const [key, value] of Object.entries(data)) {
      Object.defineProperty(Config, key, {
        value,
        writable: false,
        enumerable: true,
        configurable: false
      });
    }
  }

  // Static method to get properties safely
  static get(property) {
    if (!Config.configData) {
      throw new Error(`Configuration for ${property} is not yet loaded. Please wait until the configuration is loaded.`);
    }
    
    return Config[property];
  }

  static getOptional(property) {
    return Config.configData ? Config[property] : undefined;
  }
}

export default Config;
